import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Spinner = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Spinner({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 3.25C12 3.52614 11.7759 3.74842 11.5003 3.76514C10.0443 3.85349 8.63438 4.32665 7.41655 5.14038C6.05984 6.0469 5.00242 7.33537 4.378 8.84286C3.75358 10.3504 3.5902 12.0092 3.90853 13.6095C4.22685 15.2098 5.01259 16.6798 6.16637 17.8336C7.32016 18.9874 8.79017 19.7732 10.3905 20.0915C11.9909 20.4098 13.6497 20.2464 15.1571 19.622C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.6734 15.3656 20.1465 13.9558 20.2349 12.4997C20.2516 12.2241 20.4739 12 20.75 12H21.25C21.5261 12 21.7513 12.224 21.7372 12.4998C21.6472 14.2527 21.0854 15.9523 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46927 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.04774 2.9146 9.74729 2.35278 11.5002 2.26282C11.776 2.24866 12 2.47386 12 2.75V3.25Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'spinner-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Spinner;
